import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/not-found.css';

export const NotFoundView: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="updates-view">
      <div className="main-content">
        <div className="profile-header">
          <h1>Not Found</h1>
        </div>
        <div className="content-panel">
          <div className="not-found-content">
            <div className="not-found-icon">
              <svg width="128" height="128" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.34484649,4.5 L13.4385965,4.5 L18,9.00704225 L18,18.0211268 C18,18.4201898 17.845579,18.7664305 17.5367325,19.0598592 C17.2278859,19.3532879 16.8715298,19.5 16.4676535,19.5 L7.34484649,19.5 C6.9409702,19.5 6.58461412,19.3532879 6.27576754,19.0598592 C5.96692097,18.7664305 5.8125,18.4201898 5.8125,18.0211268 L5.84813596,5.97887324 C5.84813596,5.57981021 5.99661767,5.23356954 6.29358553,4.94014085 C6.59055339,4.64671215 6.9409702,4.5 7.34484649,4.5 Z M12.75,9.5625 L17.0625,9.5625 L12.75,5.4375 L12.75,9.5625 Z" 
                  fill="#D9D9D9"/>
              </svg>
            </div>
            <h2>Page Not Found</h2>
            <p>The requested page does not exist.</p>
            <button onClick={() => navigate('/')} className="go-home-button">
              Go To Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}; 